<template>
  <div>
    <v-row>
      <v-col cols="11">
        <v-card-title class="titulopagina">BITÁCORA</v-card-title>
      </v-col>
      <v-col cols="1">
        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
          <v-icon color="blue" large>help</v-icon>
        </v-alert>
      </v-col>
    </v-row>
    <modal-ayuda></modal-ayuda>
    <v-row class="mt-1">
      <v-card width="100%">
        <v-tabs background-color="green darken-1" class="mt-1" center-active dark>
          <v-tab v-for="menu in puntos_medicion" :key="menu.id" @click="obtenerParametros(menu.id)">{{ menu.nombre_punto
            }}</v-tab>
        </v-tabs>
      </v-card>
    </v-row>
    <!-- nuevo panel -->
    <v-row>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header
            style="margin-bottom:-5px; margin-top:0px; padding-bottom:-5px!important; padding-top:0px!important">
            <v-col cols="2">
              
            </v-col>
            <v-col cols="2">
              <v-card class="info" elevation="8">
                <p class="nombrepuntito" align="center" justify="center" v-text="punto_medicion_actual.nombre_punto">
                </p>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-alert type="info" dense outlined>Clic acá para mostrar/ocultar opciones de búsquedas por fecha y
                exportación</v-alert>
            </v-col>
            <v-col cols="1">
              <v-btn v-if="$tienePermiso('PRODUCCION_guardar_config_historica_parametro')" color="green darken-1"
                class="" dark @click.stop="guardarConfiguracionParametros()">
                <v-icon>save</v-icon> Guardar Configuración
              </v-btn>
            </v-col>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="6">
                <v-card elevation="4" color="#c8e6c9" class="mx-auto">
                  <v-container>
                    <v-row dense>
                      <v-col cols="4">
                        <b>Exportar a Excel </b>
                      </v-col>
                      <v-col cols="8">
                        <v-radio-group class="ml-3" v-model="opcion_excel" row>
                          <v-radio label="Hoja Actual" :value="1"></v-radio>
                          <v-radio label="Todo" checked :value="0"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <date-picker class="ml-2" v-model="rango_fechas"
                          placeholder="Seleccione Fecha a Exportar a Excel" range format="DD-MM-YYYY"
                          valueType="YYYY-MM-DD"></date-picker>
                      </v-col>
                      <v-col cols="4">
                        <v-select class="ml-4" v-model="conf_historica_id" :items="configuraciones_historicas"
                          item-text="nombre" item-value="id" label="Seleccione Configuracion" color="blue darken-3"
                          persistent-hint single-line dense></v-select>
                      </v-col>
                      <v-col cols="3">
                        <v-btn small color="green darken-1" class="ml-2 mr-2" dark @click.stop="descargarExcel()">
                          <v-icon>description</v-icon> Excel
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="1">
                <v-card elevation="4" color="#c8e6c9" class="mx-auto">
                  <v-container>
                    <v-row dense>
                      <v-col>
                        <b>Orden</b>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-radio-group class="ml-3" v-model="orden_fechas" row>
                          <v-radio label="ASC" :value="1" title="Ascendente"></v-radio>
                          <v-radio label="DESC" :value="0" title="Descendente"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="5">
                <v-card elevation="4" color="#80d8ff" class="mx-auto">
                  <v-container>
                    <v-row dense>
                      <b>Mostrar Bitácora Fecha : </b>
                    </v-row>
                    <v-row dense>
                      <v-spacer></v-spacer>
                      <v-col cols="8">
                        <date-picker range range-separator="|" :confirme="true" v-model="fecha_picker"
                          format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                      </v-col>
                      <v-col cols="4">
                        <v-btn small color="blue darken-2" class="ml-2 mr-2" dark
                          @click="buscar_registros">Buscar</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <!-- nuevo panel -->

    <v-row>
      <v-col>
        <v-btn small max-width="140" color="green darken-3 ml-2 mb-2" @click.stop="agregarFila()"
                :disabled="mostrarBotonAgregar || editables || add_fila || agregandoFila || cooldownActivo"
                :loading="agregandoFila"
                :class="[{ 'white--text': !mostrarBotonAgregar }]">
          <v-icon>add</v-icon> Agregar Fila
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col style="padding-top:0.5em;">
        <tabla-registro class="ml-2 mr-2"></tabla-registro>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
// import axios from 'axios'
import Tabla_Registro from '@/components/shared/Tabla_Registro.vue';
import Loader_Lineal from '@/components/shared/Loader_Lineal.vue';
import Loader_Lineal_Configurable from '../../components/shared/Loader_Lineal_Configurable.vue';

//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
  data: () => ({
    roles_permitidos: ['laboratorio', 'admin'],
    configuraciones_historicas: [],
    conf_historica_id: 0,
    punto_medicion_actual: {},
    puntos_medicion: [],
    add_fila: false,
    agregandoFila: false, // Add this new property
    cooldownActivo: false, // Add cooldown protection
    ultimaEjecucion: 0, // Track last execution time
    mostrar_fecha: false,
    mostrar_inicio: false,
    mostrar_termino: false,
    mostrarFechas: false,
    mostrarDescargarExcel: false,
    fecha_picker: new Date().toISOString().substr(0, 10),
    rango_fechas: '',
    fecha_inicio: new Date().toISOString().substr(0, 10),
    fecha_termino: new Date().toISOString().substr(0, 10),
    opcion_excel: 0,
    orden_fechas: 0,
    ajustes_tabla: {
      columnas_inicio: [
        {
          titulo: '',
          titulo_visible: true,
          cabecera: 'Fecha - Hora',
          colspan: 2,
          subcolumnas: [
            { cabecera: 'Fecha', key: 'fecha', visible: true, fixed: 1, tipo: 'texto' },
            { cabecera: 'Hora', key: 'hora', width: '70px;', visible: true, fixed: 2, tipo: 'texto' },
          ]
        },
        {
          titulo: '',
          titulo_visible: true,
          cabecera: '',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Observación', key: 'observacion', visible: true, fixed: 0, tipo: 'comentario' },
          ]
        }
      ],
      columnas_final: [
        {
          titulo: '',
          titulo_visible: true,
          cabecera: 'Usuarios',
          colspan: 3,
          subcolumnas: [
            { cabecera: 'Analista', key: 'analista_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'Analista' },
            { cabecera: 'Muestreador', key: 'muestreador_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'Muestreador' },
            { cabecera: 'J. Turno', key: 'jefe_turno_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'J. Turno' },
          ]
        }
      ],
      tipos: [],
      acciones: []
    },
    registros: [],
    analistas: [],
    muestreadores: [],
    jturnos: []
  }),
  mounted() {
    this.comprobarPermisos();
    
    // Enhanced event listeners with better error handling
    Event.$on('desbloquear_agregar_fila', () => {
      // console.log('Event: desbloquear_agregar_fila received');
      this.add_fila = false;
      this.agregandoFila = false;
      this.iniciarCooldown();
    });
    
    Event.$on('fila_agregada_exitosamente', () => {
      // console.log('Event: fila_agregada_exitosamente received');
      this.agregandoFila = false;
      this.add_fila = false;
      this.iniciarCooldown();
    });
    
    Event.$on('error_agregar_fila', () => {
      // console.log('Event: error_agregar_fila received');
      this.agregandoFila = false;
      this.add_fila = false;
      this.iniciarCooldown();
    });
    
    // Add a catch-all event listener to ensure the button gets re-enabled
    Event.$on('operacion_completada', () => {
      // console.log('Event: operacion_completada received');
      this.agregandoFila = false;
      this.add_fila = false;
      this.iniciarCooldown();
    });
    // this.cargarPuntosMedicion();
    //console.log('fecha picker',this.fecha_picker);
  },
  methods: {
    abrirAyudas() {
      const jiji = [
        { titulo: `Ayuda de Bitácora`, tipo: `titulo` },
        { tipo: `label`, texto: `En esta pantalla se registran los maxisacos de cada lote según los análisis que se obtuvieran.` },
        { tipo: `label`, texto: `- En la barra de desplazamiento de arriba se selecciona el punto de medición de la bitácora.` },
        { tipo: `label`, texto: `- En la tabla inferior se muestra cada maxisaco, la fecha y hora de producción, observaciones, código, lote, número de maxisaco y los resultados de los análisis por cada parámetro que corresponda los cuales se pueden modificar con la información pertinente. La información se guardará al realizar un cambio (o pulsar enter) en cada cuadro de texto.` },
        { tipo: `label`, texto: `- Con el botón de "Agregar Fila" se añadirá un registro a la bitácora según lo indicado que tendrá por defecto la fecha y hora actual, con el resto de datos disponibles para su llenado.` },
        { tipo: `label`, texto: `- Con el botón con el icono de una "i" y el texto de "Clic acá para mostrar/ocultar opciones de búsquedas por fecha y exportación", se abre un menú de opciones para la exportación en formato Excel de la bitácora en recuadro de color verde, en el que se puede indicar las fecha que se quiere exportar o la hoja actual y el orden en que se quiere que se muestren los registros. Con el botón "Excel" se realiza la exportación.` },
        { tipo: `label`, texto: `- El recuadro celeste (luego de mostrar opciones) sirve para buscar la bitácora según la fecha indicada. Con el botón "buscar" se realiza esta búsqueda y finalmente se muestra en la tabla de abajo la bitácora de esa fecha indicada.` },
      ];

      Event.$emit('mostrar_alert', jiji);
    },
    async comprobarPermisos() {
      let acceder = false;
      await this.roles_permitidos.forEach(async (rol) => {
        let find = this.roles.find(r => r == rol);
        if (find) {
          acceder = true;
        }
        /* await this.roles.forEach(rol_u => {
          if(rol_u == rol){
            acceder = true;
          }
        }); */
      });
      if (!acceder) {
        this.$router.push('/');
      } else {
        this.cargarPuntosMedicion();
        this.cargarConfiguracionesHistoricas();
      }
      this.verSistema();
    },
    async verSistema() {
      let url = `${this.base_url}puntodos`
      await this.axios.get(url, this.headers).then((response) => { }).catch((error) => { console.log('error', error) });
    },
    async cargarConfiguracionesHistoricas() {
      let url = `${this.base_url}configuraciones_historicas`
      await this.axios.get(url, this.headers).then((response) => {
        //console.log('puntos de medicion',response.data.data)
        this.configuraciones_historicas = response.data.data
        this.configuraciones_historicas.unshift({
          id: 0,
          nombre: 'Actual'
        })
      }).catch((error) => {
        console.log('error', error)
      })
    },
    async cargarPuntosMedicion() {
      //this.mostrarLoading('Cargando Puntos de Medición...')
      this.mostrarLoading({ titulo: 'Cargando Puntos de Medición...', color: 'green' })

      let url = `${this.base_url}punto_medicion`
      await this.axios.get(url, this.headers).then((response) => {
        //console.log('puntos de medicion',response.data.data)
        this.puntos_medicion = response.data.data
        this.puntos_medicion.sort(function (a, b) { return a.orden - b.orden });
        this.ocultarLoading()
        this.obtenerParametros(this.puntos_medicion[0].id)
      }).catch((error) => {
        console.log('error', error)
        this.ocultarLoading()
      })
    },
    async obtenerParametros(id) {
      //this.mostrarLoading('Cargando...');
      this.mostrarLoading({ titulo: 'Cargando...', color: 'green' })

      this.restablecerAjustes();

      let pm = this.puntos_medicion.filter((punto) => {
        return punto.id == id;
      });
      this.punto_medicion_actual = pm[0];
      // console.log('punto de medicion actual',this.punto_medicion_actual);
      let punto_medicion_id = pm[0].id;

      //agrega las columnas adicionales que son unicas dependiendo del tipo de punto de medicion (linea,jumbo)
      await this.agregarColumnasAdicionales(pm[0].tipo_punto);
      //agrega los usuarios analistas, muestreadores y jefes de turno
      await this.cargarUsuarios();
      //carga los ultimos 20 registros del punto de medicion seleccionado
      await this.cargarUltimosRegistros(punto_medicion_id);

      // console.log('punto_mediciones_id',id);
      //peticion que carga los parametros de un punto de medicion
      let url = `${this.base_url}punto_medicion/parametros/${id}`;
      //this.mostrarLoading('Generando Tabla...');
      this.mostrarLoading({ titulo: 'Generando Tabla...', color: 'green' })

      await this.axios.get(url, this.headers).then((response) => {

        let parametros = response.data.data;
        //realiza una busqueda de los tipos de equipo que sean distintos
        let tipos = this.buscarTiposEquiposDistintos(parametros);
        //console.log('tipos de equipo distintos',tipos);

        //busca todos los equipos que sean distintos (ademas carga los parametros del equipo)
        let equipos_distintos = this.buscarEquiposDistintos(parametros);
        //console.log('equipos_distintos',equipos_distintos);

        // asigna los equipos a los tipos de equipo
        let ajustes_finales = this.asignarEquiposATiposDeEquipo(tipos, equipos_distintos);
        //console.log('ajustes_finales',ajustes_finales);

        //se realiza el seteo de los ajustes para la tabla_registro
        this.ajustes_tabla.tipos = ajustes_finales;
        //this.ajustes_tabla.equipos = this.buscarEquiposDistintos(indicadores)
        //console.log('ajustes_tabla',this.ajustes_tabla);
        Event.$emit('crear_tabla', this.ajustes_tabla, this.registros, this.punto_medicion_actual);
        this.ocultarLoading();
      }).catch((error) => {
        console.log('error', error);
        this.ocultarLoading();
      })
    },

    async cargarUltimosRegistros(punto_medicion_id) {
      //this.mostrarLoading('Cargando Últimos Registros...');
      this.mostrarLoading({ titulo: 'Cargando Últimos Registros...', color: 'green' });
      let inicio = null;
      let termino = null;
      if (this.fecha_picker) {
        inicio = ((this.fecha_picker[0] != null) && (this.fecha_picker[0].length > 6)) ? this.fecha_picker[0] : null;
        termino = ((this.fecha_picker[1] != null) && (this.fecha_picker[1].length > 6)) ? this.fecha_picker[1] : null;
      }
      //console.log('inicio',inicio,'termino',termino);

      let url = `${this.base_url}punto_medicion/resultados/${punto_medicion_id}/${inicio}/${termino}`;
      await this.axios.get(url, this.headers).then((response) => {
        // console.log('ultimos registros laboratorio',response.data.data);
        this.registros = response.data.data;
        this.ocultarLoading();
      }).catch((error) => {
        console.log('error', error);
        this.ocultarLoading();
      })
    },

    asignarEquiposATiposDeEquipo(tipos, equipos_distintos) {
      tipos.forEach(tipo => {
        let colspan = 0;
        equipos_distintos.forEach(equipo => {
          if (tipo.tipo_equipo_id == equipo.tipo_equipo_id) {
            tipo.equipos.push(equipo)
            colspan += equipo.colspan;
          }
        });
        //ordenando los equipos de cada tipo de equipo
        tipo.equipos = tipo.equipos.sort(function (a, b) { return a.orden - b.orden });
        //console.log('equipos_ordenados',tipo.equipos);
        tipo.colspan = colspan;
      });
      return tipos;
    },

    buscarTiposEquiposDistintos(parametros) {
      let map = new Map();
      let tipos = [];
      parametros.forEach(par => {
        if (!map.has(par.equipos_procesos.tipo_equipos_id)) {
          map.set(par.equipos_procesos.tipo_equipos_id, true);
          tipos.push({
            tipo_equipo_id: par.equipos_procesos.tipo_equipos_id,
            tipo_equipo: par.equipos_procesos.tipo_equipo.mostrar_texto == 1 ? par.equipos_procesos.tipo_equipo.tipo_equipo : '',
            visible: true,
            equipos: [],
            mostrar_texto: par.equipos_procesos.tipo_equipo.mostrar_texto
          });
        }
      });

      return tipos;
    },

    buscarEquiposDeTipoDeEquipo(parametros, tipo_equipo_id) {
      let equipos = [];
      let equipos_distintos = this.buscarTiposEquiposDistintos(parametros);
      equipos_distintos.forEach(equipo => {
        if (equipo.tipo_equipo_id == tipo_equipo_id) {
          equipos.push(equipo);
        }
      });

      return equipos;
    },


    //acá se setean las keys de los parametros
    buscarEquiposDistintos(array) {
      // console.log('parametros',array);
      //array corresponde a los parametros
      let map = new Map();
      let equipos = [];
      array.forEach(item => {
        //llenando los parametros
        //this.ajustes_tabla.indicadores.push({id:item.id,nombre_indicador:item.indicadores.nombre_indicador,visible:true,fixed:0})
        //buscando los equipos distintos
        if (!map.has(item.equipos_procesos_id)) {
          map.set(item.equipos_procesos_id, true);    // set any value to Map

          //buscando los parametros del equipo
          let parametros = [];
          array.forEach(parametro => {
            if (parametro.equipos_procesos_id == item.equipos_procesos_id) {
              parametros.push({
                id: parametro.id,
                nombre_parametro: parametro.parametros.nombre_parametro,
                nombre_equipo: parametro.equipos_procesos.nombre_equipo,
                equipos_procesos_id: parametro.equipos_procesos_id,
                unidad_medida: parametro.unidad_medida.nombre_corto,
                orden: parametro.orden,
                visible: true,
                formula: parametro.formulas,
                valor_minimo: parametro.valor_minimo,
                valor_maximo: parametro.valor_maximo,
                alarma_1: parametro.alarma01,
                signo_1: parametro.signo01,
                alarma_2: parametro.alarma02,
                signo_2: parametro.signo02,
                optimo_minimo: parametro.optimo_minimo,
                optimo_maximo: parametro.optimo_maximo,
                tipo: parametro.parametros.tipo,
                opciones: parametro.parametros.opciones_activas,
                prorrateable: parametro.prorrateable,
                cantidad_decimales: parametro.cantidad_decimales,
                fixed: 0
              });
            }
          });

          //ordenando los parametros
          parametros = parametros.sort(function (a, b) { return a.orden - b.orden });

          //agregando el equipo con sus parametros
          equipos.push({
            equipos_procesos_id: item.equipos_procesos_id,
            tipo_equipo_id: item.equipos_procesos.tipo_equipos_id,
            parametros: parametros,
            cabecera: item.equipos_procesos.nombre_equipo,
            colspan: this.calcularColspan(item.equipos_procesos_id, array),
            orden: item.equipos_procesos.orden
          });
        }
      })
      return equipos;
    },
    calcularColspan(id_equipo, array) {
      let colspan = 0;
      array.forEach(item => {
        if (item.equipos_procesos_id == id_equipo) {
          colspan++;
        }
      });
      return colspan;
    },

    restablecerAjustes() {
      this.ajustes_tabla = {
        columnas_inicio: [
          {
            titulo: '',
            titulo_visible: true,
            cabecera: 'Fecha - Hora',
            colspan: 2,
            subcolumnas: [
              { cabecera: 'Fecha', key: 'fecha', visible: true, fixed: 1, tipo: 'texto' },
              { cabecera: 'Hora', key: 'hora', visible: true, fixed: 2, tipo: 'texto' },
            ]
          },
          {
            titulo: '',
            titulo_visible: true,
            cabecera: '',
            colspan: 1,
            subcolumnas: [
              { cabecera: 'Observación', key: 'observacion', visible: true, fixed: 0, tipo: 'comentario' },
            ]
          }
        ],
        columnas_final: [
          {
            titulo: '',
            titulo_visible: true,
            cabecera: 'Responsable',
            colspan: 3,
            subcolumnas: [
              { cabecera: 'Analista', key: 'analista_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'Analista' },
              { cabecera: 'Muestreador', key: 'muestreador_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'Muestreador' },
              { cabecera: 'J. Turno', key: 'jefe_turno_id', visible: true, fixed: 0, tipo: 'select', opciones: [], texto: 'name', seleccion: 'id', label: 'J. Turno' },
            ]
          }
        ],
        tipos: [],
        acciones: []
      };
      this.registros = [];
    },

    async agregarColumnasAdicionales(tipo_punto) {
      if (tipo_punto == 'linea') {

        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Materia Prima',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'MP', key: 'tipo_mps_id', visible: true, solo_lectura: false, fixed: 0, tipo: 'select', opciones: [], texto: 'tipo_materia_prima', seleccion: 'id', label: 'Materia Prima' },
          ]
        });
        await this.cargarMateriasPrimas();
      } else if (tipo_punto == 'jumbo') {
        /*this.ajustes_tabla.columnas_inicio.push({
          titulo:'',
          titulo_visible:true,
          cabecera:'Codigo',
          colspan:1,
          subcolumnas:[
            {cabecera:'Ticket',key:'codigo_ticket',visible:true,fixed:0,tipo:'texto'}
          ]
        });*/
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Proceso',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Barrido', key: 'barrido', visible: true, solo_lectura: false, fixed: 0, tipo: 'radio', title: 'Dejar en azul para indicar que es maxisaco de Barrido' },
          ]
        });


        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'C.Planta',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'C.Planta', key: 'control_planta', visible: true, solo_lectura: true, fixed: 0, tipo: 'texto' }
          ]
        });
        let jumbos_reproceso = await this.cargarJumbosReprocesoPorAsignar();
        jumbos_reproceso.unshift({ id: '', lote_jumbo: 'No Proviene' });
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Repaso',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Viene de', key: 'viene_del_jumbo', visible: true, tamanio: '120px !important;', solo_lectura: false, fixed: 0, tipo: 'autocomplete', opciones: jumbos_reproceso, texto: 'lote_jumbo', seleccion: 'id', label: '' },
          ]
        });
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: '',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Asignar Maxisaco', key: 'asignar_jumbo', visible: true, fixed: 0, tipo: 'label' }
          ]
        });
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Lote',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'N° Lote', key: 'nombre_lote', visible: true, fixed: 0, tipo: 'label' }
          ]
        });
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Maxisaco',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Maxisaco N°', key: 'nro_jumbo', visible: true, fixed: 0, tipo: 'label' }
          ]
        });
        this.ajustes_tabla.columnas_final.push({
          titulo: '',
          titulo_visible: true,
          cabecera: '',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Marcar', key: 'marcar', visible: true, fixed: 0, tipo: 'label' },
          ]
        });
        console.log(this.ajustes_tabla.columnas_inicio);
      } else if (this.punto_medicion_actual.id == 8) {
        /**punto de medicion lotes completos */
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: '',
          colspan: 2,
          subcolumnas: [
            { cabecera: 'Lote', key: 'lotes_id', visible: true, solo_lectura: false, fixed: 0, tipo: 'select', opciones: await this.cargarLotes(), texto: 'nombre_lote', seleccion: 'id', label: 'Seleccione Lote' },
            { cabecera: 'Total Kilos', key: 'total_kilos_lote', visible: true, solo_lectura: false, fixed: 0, tipo: 'label' }
          ]
        });

        // await this.cargarLotes();
      } else if ((tipo_punto == 'despacho')) { //  || (tipo_punto == 'muestras')
        this.ajustes_tabla.columnas_inicio.push({
          titulo: '',
          titulo_visible: true,
          cabecera: 'Patente',
          colspan: 1,
          subcolumnas: [
            { cabecera: 'Patente', key: 'patente', visible: true, solo_lectura: false, fixed: 0, tipo: 'texto' }
          ]
        });
        await this.cargarMateriasPrimas();
      }
    },

    // async cargarMateriasPrimas(){
    //   configuracion_mp/3/tipo_mps
    //   this.mostrarLoading('Cargando Tipos de Materias Primas...');
    //   //configuracion id 1 indica que son la materia prima que se utiliza en laboratorio
    //   await this.axios.get(`${this.base_url}tipo_mps/configuracion/1`,this.headers).then((response)=>{
    //     this.ajustes_tabla.columnas_inicio[2].subcolumnas[0].opciones = response.data;
    //     // console.log('materias_primas',response.data);
    //     this.ocultarLoading();
    //   }).catch((error)=>{
    //     console.log('error',error);
    //     this.ocultarLoading();            
    //   })
    // },

    async cargarMateriasPrimas() {
      //this.mostrarLoading('Cargando Tipos de Materias Primas...');
      this.mostrarLoading({ titulo: 'Cargando Tipos de Materias Primas...', color: 'green' })

      //configuracion id 1 indica que son la materia prima que se utiliza en laboratorio
      await this.axios.get(`${this.base_url}configuracion_mp/1/tipo_mps`, this.headers).then((response) => {
        this.ajustes_tabla.columnas_inicio[2].subcolumnas[0].opciones = response.data.data;
        //console.log('materias_primas',response.data.data);
        this.ocultarLoading();
      }).catch((error) => {
        console.log('error', error);
        this.ocultarLoading();
      })
    },

    async cargarJumbosReprocesoPorAsignar() {
      //this.mostrarLoading('Cargando Maxisacos en Reproceso sin asignar');
      this.mostrarLoading({ titulo: 'Cargando Maxisacos en Repaso sin asignar...', color: 'green' })

      let url = `${this.base_url}jumbos_repaso/por_asignar`;
      let jumbos_reproceso = [];
      await this.axios.get(url, this.headers).then((response) => {
        jumbos_reproceso = response.data.data;
        this.ocultarLoading();
      }).catch((error) => {
        console.log('error', error);
        this.ocultarLoading();
      });
      return jumbos_reproceso;
    },

    async cargarLotes() {
      //this.mostrarLoading('Cargando Lotes...');
      this.mostrarLoading({ titulo: 'Cargando Lotes...', color: 'green' })

      let lotes = [];
      //configuracion id 1 indica que son la materia prima que se utiliza en laboratorio
      await this.axios.get(`${this.base_url}lotes?limit=9999999999`, this.headers).then((response) => {
        lotes = response.data.data.data;
        // this.ajustes_tabla.columnas_inicio[2].subcolumnas[0].opciones = response.data.data;
        //console.log('lotes',response.data.data.data);
        this.ocultarLoading();
      }).catch((error) => {
        console.log('error', error);
        this.ocultarLoading();
      });
      return lotes;
    },

    async cargarUsuarios() {
      let usuarios = [];
      //this.mostrarLoading('Cargando Analistas, Muestreadores y Jefes de Turno');
      this.mostrarLoading({ titulo: 'Cargando Analistas, Muestreadores y Jefes de Turno...', color: 'green' })

      await this.axios.get(`${this.base_url}user`, this.headers).then((response) => {
        usuarios = response.data.data;
      }).catch((error) => {
        console.log('error', error);
      });

      await this.separarUsuarios(usuarios);
    },

    async separarUsuarios(usuarios) {
      this.analistas = [];
      this.muestreadores = [];
      this.jturnos = [];
      await usuarios.forEach(async (u) => {
        await u.roles.forEach(rol => {
          if (rol.id == 2) {
            this.jturnos.push(u);
          } else if (rol.id == 3) {
            this.analistas.push(u);
          } else if (rol.id == 4) {
            this.muestreadores.push(u);
          }
        });
      });
      this.ajustes_tabla.columnas_final[0].subcolumnas[0].opciones = this.analistas;
      this.ajustes_tabla.columnas_final[0].subcolumnas[1].opciones = this.muestreadores;
      this.ajustes_tabla.columnas_final[0].subcolumnas[2].opciones = this.jturnos;
    },

    agregarFila() {
      // Enhanced protection against double execution
      if (this.agregandoFila || this.add_fila || this.mostrarBotonAgregar || this.editables || this.cooldownActivo) {
        console.warn('agregarFila() blocked - already in progress or not allowed');
        return;
      }
      
      // Check if enough time has passed since last execution (additional safety)
      const ahora = Date.now();
      if (ahora - this.ultimaEjecucion < 2000) {
        console.warn('agregarFila() blocked - cooldown period active');
        return;
      }
      
      // console.log('Starting agregarFila()');
      
      // Set timestamp and flags immediately
      this.ultimaEjecucion = ahora;
      this.add_fila = true;
      this.agregandoFila = true;
      this.cooldownActivo = true;
      
      // Force Vue to update the DOM immediately
      this.$nextTick(() => {
        let tipo = {
          tipo: this.punto_medicion_actual.tipo_punto,
          punto_medicion_id: this.punto_medicion_actual.id
        };
        
        // console.log('Emitting agregar_fila event', tipo);
        Event.$emit('agregar_fila', tipo);
        
        // Enhanced timeout with more aggressive reset
        setTimeout(() => {
          if (this.agregandoFila || this.add_fila) {
            console.warn('Timeout reached for agregar_fila operation - forcing reset');
            this.agregandoFila = false;
            this.add_fila = false;
            this.iniciarCooldown();
            // Emit a general completion event as fallback
            Event.$emit('operacion_completada');
          }
        }, 8000); // Reduced timeout to 8 seconds
      });
    },

    // Add a manual reset method in case needed
    resetAgregarFila() {
      // console.log('Manual reset of agregarFila flags');
      this.agregandoFila = false;
      this.add_fila = false;
      this.cooldownActivo = false;
    },

    // Add cooldown method
    iniciarCooldown() {
      // console.log('Starting 2-second cooldown period');
      this.cooldownActivo = true;
      setTimeout(() => {
        this.cooldownActivo = false;
        // console.log('Cooldown period ended - button fully enabled');
      }, 2000); // 2 seconds cooldown
    },

    generarExcel() {
      this.mostrarFechas = !this.mostrarFechas;
    },

    async crearExcel() {
      let fecha_inicio = this.fecha_inicio != '' ? this.moment(this.fecha_inicio).format('YYYY-MM-DD') : '';
      let fecha_termino = this.fecha_termino != '' ? this.moment(this.fecha_termino).format('YYYY-MM-DD') : '';
      let punto_medicion = this.punto_medicion_actual.id;
      if (this.opcion_excel == 0) {
        punto_medicion = 0;
      }
      let url = `${this.base_url}resultados/bitacora/${fecha_inicio}/${fecha_termino}/${punto_medicion}`;
      await this.axios.get(url, this.headers).then((response) => {
        console.log(response.data.data);
        window.location.href = response.data.data;
      }).catch((error) => {
        console.log('error', error);
      });
    },

    async descargarExcel() {
      //console.log('rango fechas',this.rango_fechas);
      if (this.rango_fechas) {
        //this.mostrarLoading('Generando Excel...');
        this.mostrarLoading({ titulo: 'Generando Excel...', color: 'green' })

        let inicio = this.rango_fechas[0];
        let termino = this.rango_fechas[1];
        let p_m = this.opcion_excel == 0 ? 0 : this.punto_medicion_actual.id;
        let orden = this.orden_fechas;
        let url = `${this.base_url}resultados/bitacora/${inicio}/${termino}/${p_m}/${orden}/${this.conf_historica_id}`;
        await this.axios.get(url, this.headers).then((response) => {
          console.log(response.data.data);
          window.location.href = response.data.data;
          this.ocultarLoading();
        }).catch((error) => {
          console.log('error', error);
          this.ocultarLoading();
        });
      }
    },

    async buscar_registros() {
      if (this.fecha_picker) {
        let inicio = this.fecha_picker[0];
        let termino = this.fecha_picker[1];
        let orden = this.orden_fechas;
        this.mostrarLoading({ titulo: 'Cargando Registros... si la búsqueda contiene mas de 2 días demorará mucho más ...', color: 'green' })

        let conf = {
          color: 'blue darken-4'
        }
        Event.$emit('mostrar', conf);
        // let fecha = this.fecha_picker != ''? this.moment(this.fecha_picker).format('YYYY-MM-DD'):'';
        let url = `${this.base_url}punto_medicion/${this.punto_medicion_actual.id}/resultados/fecha/${inicio}/${termino}/${orden}`;
        await this.axios.get(url, this.headers).then((response) => {
          console.log('resultado de analisis encontrados', response);
          this.registros = response.data.data;
          Event.$emit('crear_tabla', this.ajustes_tabla, this.registros, this.punto_medicion_actual);
          this.ocultarLoading();
        }).catch((error) => {
          console.log('error', error);
          this.ocultarLoading();
        });
      }
    },
    guardarConfiguracionParametros() {
      // SweetAlert2 de confirmación
      this.$swal.fire({
        title: "¿Guardar configuración?",
        text: "Esto guardará la configuración actual como histórica.",
        icon: "none",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "green",
        cancelButtonColor: "gray",
      }).then((result) => {
        if (result.isConfirmed) {
          // El usuario confirmó => hacemos la petición a la API
          this.mostrarLoading({ titulo: "Guardando Configuración...", color: "green" });

          const url = this.base_url + "parametro-detalles/guardar-configuracion-historica";
          this.axios
            .post(url, {}, this.headers) // body vacío {} y headers si tu API los requiere
            .then((response) => {
              this.ocultarLoading();
              // Muestra mensaje de éxito usando SweetAlert2
              this.$swal.fire({
                title: "¡Éxito!",
                text: response.data.message || "Configuración guardada exitosamente.",
                icon: "success",
              });
            })
            .catch((error) => {
              this.ocultarLoading();
              // Manejo de errores
              let errorMessage = "Ocurrió un error al guardar la configuración.";
              if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
              }
              this.$swal.fire({
                title: "Error",
                text: errorMessage,
                icon: "error",
              });
            });
        }
      });
    },

    ...mapMutations(['mostrarLoading', 'ocultarLoading'])
  },
  
  // Add beforeDestroy to clean up event listeners
  beforeDestroy() {
    Event.$off('desbloquear_agregar_fila');
    Event.$off('fila_agregada_exitosamente');
    Event.$off('error_agregar_fila');
    Event.$off('operacion_completada');
  },
  
  computed: {
    ...mapState({
      base_url: state => state.base_url,
      headers: state => state.headers,
      roles: state => state.roles_prod,
      permisos: state => state.permisos_prod
    }),
    mostrarBotonAgregar() {
      if (this.ajustes_tabla.tipos.length > 0) {
        return false;
      } else {
        return true;
      }
    },

    mostrarBotonExcel() {
      if (this.ajustes_tabla.tipos.length > 0) {
        return false;
      } else {
        return true;
      }
    },

    fecha_formateada() {
      return this.fecha_picker ? this.moment(this.fecha_picker).format('DD-MM-YYYY') : '';
    },
    editables() {
      let role = this.permisos.find(p => p.name == 'Analista');
      if (role) {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    'tabla-registro': Tabla_Registro,
    'loader-lineal': Loader_Lineal,
    'loader-configurable': Loader_Lineal_Configurable,
    DatePicker,
    'modal-ayuda': ModalAyudas,
  }
}
</script>
<style scoped>
.nombrepuntito {
  text-transform: uppercase;
  font-size: 1.3em;
  padding: 7px 0;
}
</style>
<style>
.swal2-confirm {
  color: white !important;
  font-weight: bold !important;
}

.swal2-cancel {
  background-color: gray !important;
  color: white !important;
  font-weight: bold !important;
}

.swal2-modal {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

}
</style>